import React from 'react';

const Locations = () => {
  const offices = [
    {
      country: "Mauritius (Headquarters)",
      address: "Gentilly Estate, Moka, Mauritius"
    },
    {
      country: "Zimbabwe",
      address: "37 Horatio Road, Braeside, Harare, Zimbabwe"
    },
    
    {
      country: "Zambia",
      address: "Plot No.1158 Messenger, Compound, Chipata, Zambia"
    },
    {
      country: "USA",
      address: "9 Habor Hill Court, Beacon, New York, USA, 12508"
    },
    {
      country: "South Africa",
      address: "LOT 2347 Bethel Complex, Uvongo Uvongo, Kwazulu-Natal, 4270, South Africa."
    }    
  ];
  
  const satelliteOffices = [
    {
      country: "Malawi, Mozambique, Nigeria, Tanzania, United Kingdom, UAE"
    }
  ];
  
  const partners = [
    {
      name: "BlackBurn",
      logo: "/images/partners/blackburn.png" // Update this path to your actual logo file
    },
    /*
    {
      name: "Partner 2", 
      logo: "/images/partner2-logo.png" // Add more partners as needed
    },
    {
      name: "Partner 3",
      logo: "/images/partner3-logo.png"
    }*/
    // Add more partners here as needed
  ];

  return (
    <section id="locations" className="section">
      <div className="container">
        <h2 className="section-title">Office Locations</h2>
        <div className="grid grid-2">
          {offices.map((office, index) => (
            <div key={index} className="location-card">
              <h3>{office.country}</h3>
              <p>{office.address}</p>
            </div>
          ))}
        </div>
      </div>
      
      <div className="container">
        <h2 className="section-title">Satellite Offices</h2>
        <div className="grid grid-2">
          {satelliteOffices.map((office, index) => (
            <div key={index} className="location-card" align="center">
              <h3>{office.country}</h3>
            </div>
          ))}
        </div>
      </div>
      
      <div className="container">
        <h2 className="section-title">Our Partners</h2>
        <div className="grid grid-2">
          {partners.map((partner, index) => (
            <div key={index} className="location-card" align="center">
              <div className="partner-logo">
                <a 
  href="https://www.3lack3urngroup.com/" 
  target="_blank" 
  rel="noopener noreferrer"
  className="logo-link"
>
  <img 
    src={partner.logo} 
    alt={`${partner.name} logo`}
    className="logo-image"
    onError={(e) => {
      e.target.style.display = 'none';
      e.target.nextSibling.style.display = 'block';
    }}
  />
</a>
                <span style={{display: 'none'}}>{partner.name}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Locations;